module.exports = __webpack_public_path__ + "static/img/news65.bd4f3f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/newscenter/news65.png
// module id = PeE5
// module chunks = 0